import React from "react";
import { Box, Typography, makeStyles, Link } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";
import { Theme } from "../.themes";
import clsx from "clsx";
import PriceTag from "./PriceTag";
import { CoveragePrice } from "../store/Insurance";

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    display: "flex",
    marginBottom: `${theme.spacing(2)}px`,
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(2),
      textAlign: "left",
    },
  },
  totalPriceRecord: {
    color: theme.priceText?.totalPriceColor,
    "& > *": {
      color: theme.priceText?.totalPriceColor,
    },
  },
  priceArea: {
    display: "flex",
    alignItems: "baseline",
    gap: "10px",
    "& .secondaryPrice": {
      fontWeight: "400",
    },
    "& .priceText": {
      fontSize: "16px",
    },
    "& .unitText": {
      fontSize: "12px",
    },
  },
}));

type justifyContent = "flex-start" | "space-between";

interface IPriceTextProps {
  text: string;
  url?: string;
  priceText?: string;
  textVariant?: Variant;
  justifyContent?: justifyContent;
  isTotal?: boolean;
  wrapperClassName?: string;
  textClassName?: string;
  priceTextClass?: string;
  secondaryPrice?: CoveragePrice;
  showSecondaryPrice?: boolean;
}

export const PriceText: React.FC<IPriceTextProps> = (props: IPriceTextProps) => {
  const css = useStyles();

  return (
    <Box
      component='div'
      className={clsx(css.box, props.isTotal && css.totalPriceRecord, props.wrapperClassName)}
      justifyContent={props.justifyContent ?? "space-between"}
      id='ws-price'
    >
      {props.url ? (
        <Link target='_blank' variant={props.textVariant} href={props.url} className={clsx(props.textClassName)}>
          {props.text}
        </Link>
      ) : props.text ? (
        <Typography variant={props.textVariant} className={clsx(props.textClassName)}>
          {props.text}
        </Typography>
      ) : null}
      <Box className={clsx(css.priceArea)}>
        <PriceTag
          textVariant={props.textVariant}
          priceText={props.priceText ?? ""}
          textClassName={clsx(props.textClassName, props.priceTextClass, props.isTotal && css.totalPriceRecord)}
        />
        {props.showSecondaryPrice && props.secondaryPrice?.Amount && props.secondaryPrice?.Amount !== "0" && (
          <Typography variant={props.textVariant} className={"secondaryPrice"}>
            (<span className={"priceText"}>{props.secondaryPrice?.Amount}</span>{" "}
            <span className={"unitText"}>
              {props.secondaryPrice?.Currency}/{props.secondaryPrice?.Period}
            </span>
            )
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PriceText;
